import React from "react";

function Table({ columns, data, renderActions }) {
  return (
    <div className="overflow-x-auto rounded-xl shadow">
      <table className="min-w-[640px] bg-white table-auto">
        <thead>
          <tr className="bg-gray-100 text-gray-700 text-center text-sm uppercase tracking-wider">
            {columns.map((col, idx) => (
              <th key={idx} className={`px-3 py-3 sm:px-6 ${col.width || "w-auto"}`}>
                {col.label}
              </th>
            ))}
            {renderActions && <th className="w-28 px-3 py-3 text-center sm:px-6">Acciones</th>}
          </tr>
        </thead>
          <tbody className="text-center">
          {data.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length + (renderActions ? 1 : 0)}
                className="px-3 py-6 text-center italic text-gray-400 sm:px-6"
              >
                No hay registros.
              </td>
            </tr>
          ) : (
            data.map((item, index) => (
              <tr key={item.id} className={`border-t ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}`}>
                {columns.map((col, idx) => (
                  <td key={idx} className="px-3 py-4 text-gray-800 sm:px-6">
                    {item[col.key]}
                  </td>
                ))}
                {renderActions && (
                  <td className="px-3 py-4 text-center sm:px-6">
                    {renderActions(item)}
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
